// extracted by mini-css-extract-plugin
module.exports = {"base":"DashboardAddButton_base__15soK","icon":"DashboardAddButton_icon__1HvZN"};